var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"fill-height",attrs:{"align":"center","justify":"center"}},[_vm._l((_vm.items),function(item,i){return [(item)?_c('v-col',{key:i,attrs:{"cols":"12","md":"6"}},[_c('DragFile',{ref:item.ref,refInFor:true,attrs:{"item":item}})],1):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }